/**
 * Created by andrey on 28.03.2024.
 */
const GoogleAnalyticsLogger = function () {
    this.config = {
        lifetime: "180 days"
    };
};

GoogleAnalyticsLogger.prototype.trackEvent = function (name, params) {
    connector.platform.callNative("GoogleAnalytics.logEvent", { name, params });
};

GoogleAnalyticsLogger.prototype.trackPurchase = function (product, purchase, params) {
    connector.platform.callNative("GoogleAnalytics.logPurchase", {
        params: {
            currency: params.currency,
            value: params.price,
            transaction_id: params.transactionId,
            items: [{
                item_id: product.itemId,
                item_name: product.title
            }]
        }
    });
};

GoogleAnalyticsLogger.prototype.trackAdRevenue = function (name, impressionCost, options) {
    options = options || {};

    if (name === "sticky") {
        name = "banner";
    }

    connector.platform.callNative("GoogleAnalytics.logAdRevenue", {
        params: {
            value: impressionCost,
            currency: "USD",
            ad_format: name,
            ad_placement: options.placement
        }
    });
};

GoogleAnalyticsLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.CLEVERAPPS);
};
